export default () => (
    /**
     * Ícone para alterar mosaico
     */
    <svg
        width="19"
        height="8"
        viewBox="0 0 19 8"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.43041 3.05995L2.12107 7.3234L0.9375 5.84949L7.76379 0.367908L11.5892 5.13178L17.2385 0.595359L18.4221 2.06927L11.2558 7.82382L7.43041 3.05995Z"
            fill="#BEC7DC"
        />
    </svg>

);
